// Action Types
export const IS_SIGNED_IN_RECEIVED = 'IS_SIGNED_IN_RECEIVED'
export const REDIRECT_TO_HOME = 'REDIRECT_TO_HOME'
export const SIGNUP_REQUESTED = 'SIGNUP_REQUESTED'
export const SIGNUP_RECEIVED = 'SIGNUP_RECEIVED'
export const SIGNUP_RECEIVED_FAILED = 'SIGNUP_RECEIVED_FAILED'
export const SET_URL_PARAMS = 'SET_URL_PARAMS'
export const PROVIDE_EMAIL_CLICKED = 'PROVIDE_EMAIL_CLICKED'
export const CLICK_GET_STARTED = 'CLICK_GET_STARTED'
export const CLICK_ACCEPT_TERMS = 'CLICK_ACCEPT_TERMS'
export const CLICK_SUBMIT_NAME = 'CLICK_SUBMIT_NAME'
export const CLICK_SUBMIT_DOB = 'CLICK_SUBMIT_DOB'
export const CONFIRM_SIGNUP_REQUESTED = 'CONFIRM_SIGNUP_REQUESTED'
export const CONFIRM_SIGNUP_RECEIVED = 'CONFIRM_SIGNUP_RECEIVED'
export const SIGNIN_REQUESTED = 'SIGNIN_REQUESTED'
export const SIGNIN_RECEIVED = 'SIGNIN_RECEIVED'
export const SIGNOUT_REQUESTED = 'SIGNOUT_REQUESTED'
export const SIGNOUT_RECEIVED = 'SIGNOUT_RECEIVED'
export const SIGNIN_REQUESTED_FROM_PPF_FLOW = 'SIGNIN_REQUESTED_FROM_PPF_FLOW'
export const CLOSE_EXISTING_PPF_USER_DIALOG = 'CLOSE_EXISTING_PPF_USER_DIALOG'
export const PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED'
export const PASSWORD_RESET_RECEIVED = 'PASSWORD_RESET_RECEIVED'
export const PASSWORD_RESET_SUBMIT_REQUESTED = 'PASSWORD_RESET_SUBMIT_REQUESTED'
export const PASSWORD_RESET_SUBMIT_RECEIVED = 'PASSWORD_RESET_SUBMIT_RECEIVED'
export const CLICK_SUBMIT_PHONE = 'CLICK_SUBMIT_PHONE'
export const CLICK_SUBMIT_CODE = 'CLICK_SUBMIT_CODE'
export const CHOOSE_SEX_CLICKED = 'CHOOSE_SEX_CLICKED'
export const SEE_A_DOCTOR_CLICKED = 'SEE_A_DOCTOR_CLICKED'
export const RENEW_PRESCRIPTION_CLICKED = 'RENEW_PRESCRIPTION_CLICKED'
export const USER_DETAILS_CHANGED = 'USER_DETAILS_CHANGED'

export const ONBOARDING_NEXT_SCREEN_0 = 'ONBOARDING_NEXT_SCREEN_0'
export const ONBOARDING_NEXT_SCREEN_1 = 'ONBOARDING_NEXT_SCREEN_1'
export const ONBOARDING_NEXT_SCREEN_2 = 'ONBOARDING_NEXT_SCREEN_2'

export const OTP_CODE_REQUESTED = 'OTP_CODE_REQUESTED'
export const OTP_CODE_RECIEVED = 'OTP_CODE_RECIEVED'
export const OTP_CODE_VERIFY_REQUESTED = 'OTP_CODE_VERIFY_REQUESTED'
export const OTP_CODE_VERIFY_RECEIVED = 'OTP_CODE_VERIFY_RECEIVED'
export const OTP_CODE_VERIFY_REQUEST_FAILURE = 'OTP_CODE_VERIFY_REQUEST_FAILURE'
export const RESET_PASSWORD_REQUESTED = 'RESET_PASSWORD_REQUESTED'
export const USER_LOGGED_IN_SUCCSESSFULY = 'USER_LOGGED_IN_SUCCSESSFULY'
export const REDIRECT_TO_ONE_TIME_LOGIN = 'REDIRECT_TO_ONE_TIME_LOGIN'
export const FORGET_PASSWORD_REQUESTED = 'FORGET_PASSWORD_REQUESTED'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const HMO_RESEND_SMS_REQUESTED = 'HMO_RESEND_SMS_REQUESTED'
export const HMO_RESEND_SMS_RECIEVED = 'HMO_RESEND_SMS_RECIEVED'

export const IS_MOBILE_WEB_USER = 'IS_MOBILE_WEB_USER'

export const SAVE_LOCATION_TO_NAVIGATE_AFTER_LOGGED_IN =
  'SAVE_LOCATION_TO_NAVIGATE_AFTER_LOGGED_IN'
export const STORE_RESET_HANDLER = 'STORE_RESET_HANDLER'

export const PPF_USER_LOGIN = 'PPF_USER_LOGIN'
export const TH_TO_HMO_ENROLLED_SIGNUP_REQUESTED =
  'TH_TO_HMO_ENROLLED_SIGNUP_REQUESTED'

export const DECLARE_SIGNUP_FLOW_TYPE = 'DECLARE_SIGNUP_FLOW_TYPE'
